export default {
  wantToAsk: "What want to ask",
  vip: "VIP",
  feedBack: "FeedBack",
  creatorServiceCenter: "Creator service center",
  inputPlaceholder: "Enter your valuable feedback",
  send: "Send",
  pic: "Picture",
  video: "Video",
  picLimit: "Picture size limit 20M",
  noIssue: "The above is not the problem I want",
  noMessage: "No more historical messages ~",
  inputEmpty: "The content you entered is empty!",
  maxLength: "Only up to 500 words can be entered!",
  inputContact:
    "Please enter your contact information so that we can serve you better~",
  netError: "Network error, please check your network",
  netTimeout: "Network timeout, please check your network",
  thanksFeedback:
    "Thanks for the feedback, we will solve your problem as soon as possible",
  contactInformation: "Contact information",
  contact: "whatsapp/Email/Phone number",
  uploading: "uploading...",
  uploadLimit: "The uploaded video size cannot exceed 150M",
  videoNotSupport: "The video format is not supported",
  inviteFeedback: "Invite you to fill in our feedback",
  inviteDesc:
    "If you have suggestions for improving product functions and user experience, you can submit them to us. We will feedback relevant information for optimization as soon as possible",
  inviteBtn: "Feedback",
  draftDialogTitle: "Draft upload",
  draftDialogDesc:
    "In order to solve the problem faster, please authorize the system to upload your latest draft and materials. The draft and materials are only used to analyze the problem. If you refuse the authorization, we may not be able to solve your problem in time.",
  deny: "Deny",
  accept: "Accept",
  kwaiCut: {
    slogan: "KwaiCut, create interesting videos",
    subtitle: "Video editing such as jokes, games and food",
    desc: "Kwai's video editing mobile app",
    scanDownload: "Scan code to download KwaiCut",
    featTitle1: "Comprehensive Video Clips",
    featDesc1:
      "Functions such as reverse playback, speed change and transition are all available",
    featTitle2: "Sophisticated short video editing",
    featDesc2:
      "Exquisite filters and subtitles, the video becomes a big movie in seconds",
    featTitle3: "One-click sharing to Kwai",
    featDesc3: "Video can be directly shared to Kwai",
    featTitle4: "Funny sound library",
    featDesc4: "100 popular sound effects to make your jokes more popular",
    featTitle5: "Custom cover font",
    featDesc5: "Want to be popular? An eye-catching cover is crucial",
  },
};
